export const AGGREGATORS_NS = 'components/Aggregators';

export const i18n = {
  en: {
    massFlowRate: 'Mass Flow Rate',
    massVolumeRate: 'Mass Volume Rate',
    massTotal: 'Mass Total',
    volumeTotal: 'Volume Total',
    driveGain: 'Drive Gain (%)',
    density: 'Density',
    temperature: 'Temperature',
    pressure: 'Pressure',
    driveGainAeration: 'Drive Gain & Aeration',
    placeholder: 'Bunkering metrics only visible when viewing live data.',
    tubeDamping: 'Tube Damping',
    direction: 'Direction',
  },
};
